import { LoadingSkeleton } from '@coinbase/cdp-react/components/ui/LoadingSkeleton';
import { Text } from '@cbhq/cds-web/typography';

import styles from './LoadingInput.module.css';

type Props = {
  label?: string;
};

function LoadingInput({ label }: Props) {
  return (
    <div className={styles['loading-input-wrapper']}>
      {label && (
        <Text font="label1" paddingY={0.5}>
          {label}
        </Text>
      )}
      <LoadingSkeleton className={styles['loading-input']} />
    </div>
  );
}

export { LoadingInput };
